import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["copyVariant", "heading", "subheading", "mainLink", "secondLink", "variant", "onLinkClick", "backdropLayout", "backdropColor", "media", "smallMedia"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { BREAKPOINTS } from "../../constants/breakpoints";
import React, { memo, useMemo } from 'react';
import ActionBar from "../action-bar";
import { ButtonVariant } from "../button";
import { BackdropLayout, Variant } from "./types";
import { Backdrop, Heading, Headings, Links, Media, Section, Subheading } from "./cta-module.styles";
import { defaultProps } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CtaModule = function CtaModule(_ref) {
  var copyVariant = _ref.copyVariant,
    heading = _ref.heading,
    subheading = _ref.subheading,
    mainLink = _ref.mainLink,
    secondLink = _ref.secondLink,
    variant = _ref.variant,
    onLinkClick = _ref.onLinkClick,
    backdropLayout = _ref.backdropLayout,
    backdropColor = _ref.backdropColor,
    media = _ref.media,
    smallMedia = _ref.smallMedia,
    rest = _objectWithoutProperties(_ref, _excluded);
  var hasBackdrop = variant === Variant.WithBackdrop || variant === Variant.WithBackdropAndMedia;
  var hasMedia = variant === Variant.WithBackdropAndMedia && !!media;
  var hasHorizontalBackdropLayout = variant === Variant.WithBackdrop && backdropLayout === BackdropLayout.Horizontal;
  var hasHeadings = Boolean(heading || subheading);
  var actionBar = useMemo(function () {
    return {
      primaryLink: (mainLink === null || mainLink === void 0 ? void 0 : mainLink.type) === ButtonVariant.Primary ? mainLink : undefined,
      secondaryLink: (mainLink === null || mainLink === void 0 ? void 0 : mainLink.type) === ButtonVariant.Secondary ? mainLink : (secondLink === null || secondLink === void 0 ? void 0 : secondLink.type) === ButtonVariant.Secondary ? secondLink : undefined,
      tertiaryLink: (secondLink === null || secondLink === void 0 ? void 0 : secondLink.type) === ButtonVariant.Tertiary ? secondLink : undefined,
      onClick: onLinkClick
    };
  }, [mainLink, onLinkClick, secondLink]);
  return /*#__PURE__*/_jsx(Section, _objectSpread(_objectSpread({
    variant: variant,
    copyVariant: copyVariant
  }, rest), {}, {
    children: /*#__PURE__*/_jsxs(Backdrop, {
      hasBackdrop: hasBackdrop,
      backdropColor: backdropColor,
      children: [hasHeadings && /*#__PURE__*/_jsxs(Headings, {
        alignLeft: hasHorizontalBackdropLayout || hasMedia,
        hasMedia: hasMedia,
        children: [heading && /*#__PURE__*/_jsx(Heading, {
          copyVariant: copyVariant,
          hasBackground: hasBackdrop,
          dangerouslySetInnerHTML: {
            __html: heading
          }
        }), subheading && /*#__PURE__*/_jsx(Subheading, {
          children: subheading
        })]
      }), /*#__PURE__*/_jsx(Links, {
        alignLeft: hasMedia,
        alignRight: hasHorizontalBackdropLayout,
        hasHeadings: hasHeadings,
        children: /*#__PURE__*/_jsx(ActionBar, _objectSpread({}, actionBar))
      }), hasMedia && /*#__PURE__*/_jsx(Media, {
        media: media,
        smallMedia: smallMedia,
        thresholdBreakpoint: BREAKPOINTS.md,
        hasHeadings: hasHeadings
      })]
    })
  }));
};
CtaModule.defaultProps = defaultProps;
export default /*#__PURE__*/memo(CtaModule);